import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import Loader from '../Loader';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isLoading, user, isAuthenticated } = useAuth();
  
  if (isLoading) {
    return <Loader fullScreen size="xl" />;
  }
  
  // If user is authenticated and is a barman, redirect to barman dashboard
  // Barmen should not access customer-facing routes
  if (isAuthenticated && user?.role === 'barman') {
    return <Navigate to="/barman" replace />;
  }
  
  // Allow non-authenticated users and authenticated customers/organizers to access public routes
  return <>{children}</>;
};

export default PublicRoute; 